import React from "react";
import { Text } from "@react-pdf/renderer";
import { getFontSize } from "../../utils/getFontSize";

const colors = {
  black: "hsl(132,4%,25%)",
  grey: "#73808D",
};

export const PdfText = ({
  fontSize = 14,
  fontWeight = 400,
  color = "black",
  children,
  style,
}) => {
  return (
    <Text
      style={[
        {
          fontFamily: "Roboto",
          fontSize: getFontSize(fontSize),
          fontWeight,
          color: colors[color],
          ...style,
        },
      ]}
    >
      {children}
    </Text>
  );
};
